import React from "react";

/**
 * Subtle animated drifting champagne particles for cinematic feel.
 * Keep count low to preserve performance on mobile.
 */
const Particles = ({ count = 18 }) => {
    const items = React.useMemo(
        () =>
            Array.from({ length: count }).map((_, i) => ({
                id: i,
                left: Math.random() * 100,
                top: 60 + Math.random() * 40,
                delay: -Math.random() * 14,
                duration: 12 + Math.random() * 10,
                size: 1 + Math.random() * 2.5,
                opacity: 0.25 + Math.random() * 0.5,
            })),
        [count]
    );

    return (
        <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
            {items.map((p) => (
                <span
                    key={p.id}
                    className="dust"
                    style={{
                        left: `${p.left}%`,
                        top: `${p.top}%`,
                        width: `${p.size}px`,
                        height: `${p.size}px`,
                        animationDuration: `${p.duration}s`,
                        animationDelay: `${p.delay}s`,
                        opacity: p.opacity,
                    }}
                />
            ))}
        </div>
    );
};

export default Particles;
